/**
 * Get the API base URL
 * In production, if REACT_APP_API_BASE is empty, use relative URLs (same origin)
 * This allows nginx to proxy /api/ requests to the backend
 */
export const getApiBaseUrl = () => {
  const apiBase = process.env.REACT_APP_API_BASE;
  
  // Check if we're in a production build (not just development mode)
  // React sets NODE_ENV=production during build
  const isProductionBuild = process.env.NODE_ENV === 'production';
  
  // Debug log (remove in production if needed)
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    console.log('🔧 API Base URL Config:', {
      REACT_APP_API_BASE: apiBase,
      NODE_ENV: process.env.NODE_ENV,
      isProductionBuild,
      resolved: !apiBase || apiBase === '' || apiBase === 'undefined' ? '' : apiBase
    });
  }
  
  // In production, always use relative URLs (empty string) if apiBase is not set or is empty
  // This works because nginx proxies /api/ to the backend
  if (isProductionBuild) {
    // If apiBase is undefined, null, empty string, or the string "undefined", use relative URLs
    if (!apiBase || apiBase === '' || apiBase === 'undefined' || apiBase === 'null') {
      return '';
    }
    return apiBase;
  }
  
  // In development mode, default to localhost:3000
  return apiBase || 'http://localhost:3000';
};

// Export the base URL as a constant for convenience
export const API_BASE_URL = getApiBaseUrl();
